<template>
    <v-app id="inspire">
        <!-- DESKTOP MENU -->
        <v-navigation-drawer
            v-if="!$route.meta.hideSidebar && $vuetify.breakpoint.mdAndUp"
            v-model="drawer"
            app
            class="menu"
            width="290"
            :mini-variant-width="menuMiniVariantData.width"
            :mini-variant="miniVariant"
            color="#FAFAFA"
            permanent
        >
            <div :class="['d-flex',  miniVariant ? menuMiniVariantData.toggleBtnJustifyClass : 'justify-end', 'pa-2']">
                <v-btn
                    icon
                    @click="miniVariant = !miniVariant"
                    class="toggle-btn"
                    color="primary"
                >
                    <v-icon>{{ miniVariant ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
                </v-btn>
            </div>
            <v-list flat>
                <div class="my-4">
                    <div v-if="!miniVariant">
                        <v-img
                            src="/images/OnflyLogo.svg"
                            height="auto"
                            width="120"
                            class="mx-auto"
                        />
                        <v-card-title class="flex-column">
                            <div>
                                <span class="color-blue-onfly-darker">Partner Hub</span>
                                <v-chip
                                    small
                                    color="blue"
                                >
                                    <span class="font-weight-bold text-white-50">Belchior</span>
                                </v-chip>
                            </div>
                        </v-card-title>
                    </div>
                    <div v-else>
                        <v-card-title :class="menuMiniVariantData.systemTitleClass">
                            <span class="color-grey-onfly font-weight-bold text-no-wrap">PH</span>
                        </v-card-title>
                    </div>
                </div>
                <div class="pa-0 ma-0 item-list" v-for="(list, i) in filteredLists" :key="i">
                    <v-list-item
                        v-if="!list.sublinks"
                        :to="list.forceReload ? null : list.to"
                        class="menu-item mx-0 justify-content-center"
                        @click="list.forceReload ? forceNavigate(list.to) : null"
                    >
                        <v-list-item-icon class="mr-4">
                            <v-badge
                                v-if="miniVariant && list.counter && list.counter.id && menuCounters[list.counter.id]"
                                :content="menuCounters[list.counter.id]"
                                :color="list.counter.color"
                                overlap
                                class="mt-0 menu-counter"
                            >
                                <v-icon class="color-blue-onfly-darker">
                                    {{ list.icon }}
                                </v-icon>
                            </v-badge>
                            <v-icon v-else class="color-blue-onfly-darker">
                                {{ list.icon }}
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content v-show="!miniVariant">
                            <v-list-item-title class="list-title color-grey-onfly font-weight-medium">
                                <v-badge
                                    v-if="list.counter && list.counter.id && menuCounters[list.counter.id]"
                                    :content="menuCounters[list.counter.id]"
                                    :color="list.counter.color"
                                    inline
                                    class="mt-0 menu-counter"
                                >
                                    {{ list.text }}
                                </v-badge>
                                <span v-else>
                                    {{ list.text }}
                                </span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <template v-else>
                        <v-menu open-on-hover offset-x right transition="slide-x-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on" class="menu-item mx-0">
                                    <v-list-item-icon class="mr-4">
                                        <v-badge
                                            v-if="miniVariant && list.counter && list.counter.id && menuCounters[list.counter.id]"
                                            :content="menuCounters[list.counter.id]"
                                            :color="list.counter.color"
                                            overlap
                                            class="mt-0 menu-counter"
                                        >
                                            <v-icon class="color-blue-onfly-darker">
                                                {{ list.icon }}
                                            </v-icon>
                                        </v-badge>
                                        <v-icon v-else class="color-blue-onfly-darker">
                                            {{ list.icon }}
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content v-if="!miniVariant">
                                        <v-list-item-title class="list-title color-grey-onfly font-weight-medium">
                                            <v-badge
                                                v-if="list.counter && list.counter.id && menuCounters[list.counter.id]"
                                                :content="menuCounters[list.counter.id]"
                                                :color="list.counter.color"
                                                inline
                                                class="mt-0 menu-counter"
                                            >
                                                {{ list.text }}
                                            </v-badge>
                                            <span v-else>
                                                {{ list.text }}
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-icon
                                        small
                                        class="color-blue-onfly-darker"
                                        v-if="!miniVariant"
                                    >
                                        mdi-chevron-right
                                    </v-icon>
                                </v-list-item>
                            </template>
                            <v-list class="submenu-popup">
                                <v-list-item
                                    v-for="(sublink, j) in list.sublinks"
                                    :key="j"
                                    :to="sublink.forceReload ? null : sublink.to"
                                    class="menu-item color-grey-onfly"
                                    @click="sublink.forceReload ? forceNavigate(sublink.to) : null"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-badge
                                                v-if="sublink.counter && sublink.counter.id && menuCounters[sublink.counter.id]"
                                                :content="menuCounters[sublink.counter.id]"
                                                :color="sublink.counter.color"
                                                inline
                                                class="mt-0 menu-counter"
                                            >
                                                {{ sublink.text }}
                                            </v-badge>
                                            <span v-else>
                                                {{ sublink.text }}
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </div>
                <v-list-item class="list mt-5 mx-1 menu-item" @click="logout()">
                    <v-list-item-icon class="mr-4">
                        <v-icon color="primary">mdi-account-arrow-right</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content v-show="!miniVariant">
                        <v-list-item-title class="list-title">Sair</v-list-item-title>
                    </v-list-item-content>
                    <v-tooltip v-if="miniVariant" right>
                        <template v-slot:activator="{ on }">
                            <span v-on="on"></span>
                        </template>
                        <span>Sair</span>
                    </v-tooltip>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <!-- MOBILE MENU -->
        <v-app-bar
            v-if="!$route.meta.hideSidebar && $vuetify.breakpoint.smAndDown"
            app
            color="#FAFAFA"
            elevation="1"
        >
            <v-app-bar-nav-icon color="primary" @click="mobileDrawer = !mobileDrawer" />
            <v-spacer />
            <div class="justify-end">
                <v-card-title class="flex-column">
                    <div>
                        <span class="color-blue-onfly-darker">Partner Hub</span>
                        <v-chip
                            small
                            color="blue"
                        >
                            <span class="font-weight-bold text-white-50">Belchior</span>
                        </v-chip>
                    </div>
                </v-card-title>
            </div>
        </v-app-bar>
        <v-navigation-drawer
            v-if="!$route.meta.hideSidebar && $vuetify.breakpoint.smAndDown"
            v-model="mobileDrawer"
            app
            temporary
            class="menu mobile-menu"
            width="280"
            color="#FAFAFA"
        >
            <v-list flat>
                <div class="pt-4">
                    <v-img
                        src="/images/OnflyLogo.svg"
                        height="auto"
                        width="120"
                        class="mx-auto"
                    />
                    <v-card-title class="flex-column">
                        <div>
                            <span class="color-blue-onfly-darker">Partner Hub</span>
                            <v-chip
                                small
                                color="blue"
                            >
                                <span class="font-weight-bold text-white-50">Belchior</span>
                            </v-chip>
                        </div>
                    </v-card-title>
                </div>
                <v-divider />
                <div class="pa-0 ma-0 item-list" v-for="(list, i) in filteredLists" :key="i">
                    <v-list-item
                        v-if="!list.sublinks"
                        :to="list.forceReload ? null : list.to"
                        class="mobile-menu-item"
                        @click="handleMobileMenuClick(list)"
                    >
                        <v-list-item-icon class="mr-4">
                            <v-icon class="color-blue-onfly-darker">{{ list.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="list-title color-grey-onfly font-weight-medium">
                                <v-badge
                                    v-if="list.counter && list.counter.id && menuCounters[list.counter.id]"
                                    :content="menuCounters[list.counter.id]"
                                    :color="list.counter.color"
                                    inline
                                    class="mt-0"
                                >
                                    {{ list.text }}
                                </v-badge>
                                <span v-else>
                                    {{ list.text }}
                                </span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-group
                        v-else
                        no-action
                        class="mobile-menu-list-group"
                    >
                        <template v-slot:prependIcon class="mr-4">
                            <v-icon class="color-blue-onfly-darker">{{ list.icon }}</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title class="list-title color-grey-onfly font-weight-medium">{{ list.text }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                            v-for="(sublink, j) in list.sublinks"
                            :key="j"
                            :to="sublink.forceReload ? null : sublink.to"
                            class="sub-menu-item"
                            @click="handleMobileMenuClick(sublink)"
                        >
                            <v-list-item-content>
                                <v-list-item-title class="sub-menu-title color-grey-onfly">
                                    <v-badge
                                        v-if="sublink.counter && sublink.counter.id && menuCounters[sublink.counter.id]"
                                        :content="menuCounters[sublink.counter.id]"
                                        :color="sublink.counter.color"
                                        inline
                                        class="mt-0"
                                    >
                                        {{ sublink.text }}
                                    </v-badge>
                                    <span v-else>
                                        {{ sublink.text }}
                                    </span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </div>
                <v-divider class="my-3" />
                <v-list-item class="list mobile-menu-item" @click="logout()">
                    <v-list-item-icon class="mr-4">
                        <v-icon color="primary">mdi-account-arrow-right</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="list-title">Sair</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <!-- SNACKBAR -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top center>
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">Fechar</v-btn>
            </template>
        </v-snackbar>

        <!-- MAIN CONTENT -->
        <v-main :class="[!$route.meta.hideSidebar && $vuetify.breakpoint.smAndDown ? 'mobile-menu-layout' : '']">
            <router-view />
        </v-main>

        <!-- SESSION EXPIRED DIALOG -->
        <SessionExpiredDialog :model.sync="sessionExpired" />

        <!-- SIMPLE DIALOG -->
        <simple-message-dialog ref="simpleDialog" />
    </v-app>
</template>

<script>
import SimpleMessageDialog from "./components/Dialog/SimpleMessageDialog.vue";

export default {
    components: { SimpleMessageDialog },
    data: () => ({
        drawer: true,
        miniVariant: false,
        mobileDrawer: false,
        snackbar: {
            show: false,
            text: '',
            color: 'error',
            timeout: 4000,
        },
        menuCounters: {
            hotelsToApprove: null,
        },
        lists: [
            {
                to: { name: 'home' },
                icon: 'mdi-view-dashboard',
                text: 'Dashboard',
            },
            {
                to: { name: 'hotelList' },
                icon: 'mdi-office-building',
                text: 'Listagem de Hotéis',
            },
            {
                to: { name: 'hotelsApprove' },
                icon: 'mdi-domain-plus',
                text: 'Aprovações de Hotéis',
                counter: {
                    id: 'hotelsToApprove',
                    color: 'info'
                }
            },
            {
                to: { name: 'createHotel' },
                icon: 'mdi-plus-box',
                text: 'Cadastrar Hotel',
            },
            /*{
                to: { name: 'hotelPendingChangesList' },
                icon: 'mdi-office-building-outline',
                text: 'Alteração de Hotéis',
            },*/
            {
                to: { name: 'reserveList' },
                icon: 'mdi-content-copy',
                text: 'Reservas',
            },
            {
                to: { name: 'pointOfSaleList' },
                icon: 'mdi-currency-usd',
                text: 'Pontos de Venda',
            },
            {
                to: { name: 'generalReport' },
                icon: 'mdi-file-chart',
                text: 'Relatórios',
                sublinks: [
                    {
                        to: { name: 'generalReport' },
                        text: 'Relatório Geral',
                        permissions: ['general.report'],
                    },
                    {
                        to: { name: 'hotelsReport' },
                        text: 'Relatório de Hotéis',
                        permissions: ['hotels.report'],
                    },
                    {
                        to: { name: 'emittersReport' },
                        text: 'Relatório de Emissores',
                        permissions: ['emitters.report'],
                    },
                    {
                        to: { name: 'pointsOfSaleReport' },
                        text: 'Relatório de Pontos de Venda',
                        permissions: ['point-of-sale-report.report'],
                    },
                    {
                        to: { name: 'guestsReport' },
                        text: 'Relatório de Hóspedes',
                        permissions: ['guests.report'],
                    },
                    {
                        to: {name: 'pendingCardsReport'},
                        text: 'Relatório de Cartões Pendentes',
                    },
                ]
            },
            {
                to: { name: 'userList' },
                icon: 'mdi-account-group',
                text: 'Usuários',
            },
            {
                to: { name: 'permissions' },
                icon: 'mdi-shield-account',
                text: 'Permissões',
                permissions: ['manage.permissions'],
            },
        ],
        sessionExpired: false,
        publicRouteNames: [
            'hotelPreRegistration',
            'newHotel'
        ]
    }),
    computed: {
        filteredLists() {
            const userPermissions = JSON.parse(document.getElementById('app').dataset.userPermissions);
            return this.lists
                .map(item => {
                    const hasPermission = item.permissions?.some(p =>
                        userPermissions.includes(p) || p === '*'
                    ) ?? true;

                    const filteredSublinks = (item.sublinks || []).filter(sublink =>
                        sublink.permissions?.some(p =>
                            userPermissions.includes(p) || p === '*'
                        )
                    );

                    if (hasPermission || filteredSublinks.length > 0) {
                        return {
                            ...item,
                            sublinks: filteredSublinks.length > 0 ? filteredSublinks : undefined
                        };
                    }

                    return null;
                })
                .filter(Boolean);
        },
        isPrivatePage () {
            return !this.publicRouteNames.includes(this.$route.name);
        },
        hasCountersToExhib () {
            let hasCounters = false;

            Object.values(this.menuCounters).forEach((menuCounter) => {
               hasCounters = menuCounter !== undefined &&
                   menuCounter !== null &&
                   menuCounter !== 0 &&
                   menuCounter !== '0';
            });

            return hasCounters;
        },
        menuMiniVariantData () {
            return this.hasCountersToExhib
                ? {
                    width: 70,
                    toggleBtnJustifyClass: 'justify-center',
                    systemTitleClass: 'px-4'
                }
                : {
                    width: 56,
                    toggleBtnJustifyClass: 'justify-end',
                    systemTitleClass: 'px-3'
                };
        }
    },
    created() {
        window.$toast = ({ text, color = 'error', timeout = 4000 }) => {
            this.snackbar.text = text;
            this.snackbar.color = color;
            this.snackbar.timeout = timeout;
            this.snackbar.show = true;
        };
    },
    mounted() {
        this.fetchMenuCounters();
        axios.interceptors.response.use(
            response => response,
            error => {
                if ([419, 401].includes(error.response?.status)) {
                    this.sessionExpired = this.isPrivatePage;
                }
                return Promise.reject(error);
            }
        );
    },
    methods: {
        logout() {
            axios.post('/logout').then(() => (window.location.href = '/login'));
        },
        registerUser() {
            window.location.href = '/register';
        },
        forceNavigate (to) {
            if (to) {
                const route = this.$router.resolve(to);
                window.location.href = route.href;
            }
        },
        handleMobileMenuClick (item) {
            this.mobileDrawer = false;
            if (item.forceReload) {
                this.forceNavigate(item.to);
            }
        },
        fetchMenuCounters () {
            if (!this.$route.meta.hideSidebar) {
                axios.get('/api/spa/menu-counters', { validateStatus: () => true }).then((response) => {
                    if (response.status === 200 && response.data) {
                        this.menuCounters.hotelsToApprove = response.data.hotelsToApproveCounter;
                    }
                });
            }
        }
    }
};
</script>

<style>
a:hover {
    text-decoration: initial !important;
}

.menu .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
}

.item-list:hover {
    background-color: rgba(0, 0, 0, 0.03);
}

.list-title{
    color: #212121;
    font-weight: 500;
}

.menu-logo {
    width: 60%;
    transition: all 0.3s ease;
}

.bg-blue-onfly {
    background: #009efb !important;
}

.border-blue-onfly {
    border-color: #009efb !important;
}

.bg-blue-onfly-darker {
    background: #007dc7 !important;
}

.color-blue-onfly {
    color: #009efb !important;
}

.color-blue-onfly-darker {
    color: #007dc7 !important;
}

.text-white-50 {
    color: #f7f7f9 !important;
}

.color-grey-onfly {
    color: #54667a !important;
}

.mobile-menu-list-group {
    padding-left: 4px;
    padding-right: 4px;
}

.mobile-menu-list-group .v-list-item__icon.v-list-group__header__prepend-icon {
    margin-right: 16px !important;
}

.mobile-menu-list-group a.sub-menu-item.v-list-item.v-list-item--link {
    padding-left: 12px !important;
}

.toggle-btn {
    margin-top: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
}

.toggle-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.menu-item {
    transition: all 0.2s ease;
    border-radius: 8px;
    margin: 2px 8px;
}

.menu-item:hover {
    background-color: rgba(25, 118, 210, 0.08);
    transform: translateX(4px);
}

.mobile-menu-item {
    padding: 4px 16px;
    border-radius: 8px;
    margin: 2px 8px;
    transition: all 0.2s ease;
}

.mobile-menu-item:hover {
    background-color: rgba(25, 118, 210, 0.08);
}

.sub-menu-item {
    border-radius: 8px;
    margin: 1px 8px;
    transition: all 0.2s ease;
}

.sub-menu-item:hover {
    background-color: rgba(25, 118, 210, 0.05);
}

.sub-menu-title {
    font-size: 14px;
    color: #616161;
}

.submenu-popup {
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    border-radius: 8px;
}

.v-navigation-drawer {
    transition: width 0.3s ease;
}

.v-list-group__header {
    padding-right: 16px;
}

.menu-counter .v-badge__wrapper {
    margin-left: 8px !important;
}

@media (max-width: 960px) {
    .v-main .mobile-menu-layout {
        padding-top: 58px !important;
    }
}
</style>
